var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLidl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V100H100V0H0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 3.47656C40.7972 3.47484 31.8005 6.20214 24.1477 11.3136C16.4948 16.425 10.5295 23.6909 7.00616 32.1926C3.48281 40.6943 2.55963 50.0499 4.35336 59.0763C6.1471 68.1026 10.5772 76.3944 17.0834 82.903C23.5896 89.4116 31.8798 93.8447 40.9055 95.6417C49.9312 97.4387 59.2871 96.519 67.7901 92.9987C76.2931 89.4785 83.5612 83.5158 88.6754 75.8648C93.7896 68.2138 96.5202 59.2181 96.5218 50.0153C96.5194 37.6761 91.6178 25.8428 82.8943 17.1161C74.1708 8.38941 62.3392 3.48348 50.0001 3.47656V3.47656Z",
    fill: "#FBCE30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0006 6.41797C41.3815 6.41797 32.9559 8.97361 25.7892 13.7618C18.6225 18.5499 13.0364 25.3556 9.73718 33.3182C6.43801 41.2809 5.57391 50.043 7.25414 58.4967C8.93438 66.9505 13.0835 74.7162 19.1769 80.812C25.2703 86.9078 33.0343 91.06 41.4874 92.7436C49.9404 94.4272 58.7029 93.5666 66.6669 90.2706C74.6309 86.9746 81.4387 81.3913 86.2298 74.2264C91.0208 67.0616 93.5798 58.6371 93.5832 50.018C93.5832 38.4575 88.992 27.3703 80.8192 19.1943C72.6464 11.0182 61.561 6.42258 50.0006 6.41797V6.41797Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2957 51.2269L39.6 43.5312L30.7305 52.4182V55.4008L32.9653 53.1573L39.1566 59.366L36.8696 61.6443L38.3566 63.1399L50.7392 50.7399V47.766L47.2957 51.2269Z",
    fill: "#FBCE30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.373 41.9141H25.0774V44.8706H22.7904V54.4358L30.7296 50.0184V58.1141H11.373V55.1401H13.6687V44.8706H11.373V41.9141ZM69.1557 41.9141V44.8706H71.4513V55.1401H69.1557V58.1141H88.5296V50.0184L80.5817 54.4358V44.8706H82.8774V41.9141H69.1557V41.9141Z",
    fill: "#FBCE30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4701 32.7032C39.4357 32.7032 40.3795 32.9897 41.1821 33.5265C41.9847 34.0633 42.6099 34.8262 42.9787 35.7186C43.3474 36.611 43.4429 37.5928 43.2533 38.5395C43.0637 39.4863 42.5973 40.3555 41.9133 41.037C41.2294 41.7186 40.3585 42.1818 39.4111 42.3681C38.4636 42.5543 37.4823 42.4552 36.5912 42.0833C35.7001 41.7114 34.9394 41.0835 34.4055 40.279C33.8716 39.4745 33.5884 38.5296 33.5918 37.564C33.5918 36.9242 33.7181 36.2907 33.9635 35.6998C34.2089 35.1089 34.5685 34.5723 35.0217 34.1207C35.4749 33.6691 36.0128 33.3114 36.6046 33.0682C37.1963 32.8249 37.8303 32.7009 38.4701 32.7032V32.7032Z",
    fill: "#FBCE30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4786 41.9141V44.871H50.7663V55.141H48.4531V58.1148H61.4966C71.1836 58.1148 71.3047 41.9141 61.5221 41.9141H48.4786L48.4786 41.9141ZM59.0356 46.9583H59.5825C62.4434 46.9583 62.4443 53.0453 59.6878 53.0453H59.0356V46.9583Z",
    fill: "#FBCE30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidl);
export default __webpack_public_path__ + "static/media/lidl.c58624bc6defe804247ea8dc899cb2ca.svg";
export { ForwardRef as ReactComponent };